// extracted by mini-css-extract-plugin
export default {"image":"video_image__+fVYV","image-area":"video_image-area__JFsrq","inputs":"video_inputs__Jr4vC","scale-video":"video_scale-video__u4je7"};